import { PointsStrategy } from '@ocx/graphql';

import { LoyaltyCurrencyIconConfig } from './loyalty-currency.types';

export const loyaltyCurrencyIconDefaultConfig: Record<
  Exclude<PointsStrategy, PointsStrategy.NotUsed>,
  LoyaltyCurrencyIconConfig
> = {
  [PointsStrategy.Points]: {
    multiple: 'CoinsIcon',
    single: 'CoinIcon',
  },
  [PointsStrategy.Cents]: {
    multiple: 'DollarsCoinsIcon',
    single: 'DollarCoinIcon',
  },
};
